import React from 'react';
import { ImageBackground, View } from 'react-native';
import { Colors } from 'react-native-paper';
import { useSelector } from 'react-redux';
import gym_insitu from '../../../assets/images/gym_insitu.jpg';
import gym_online from '../../../assets/images/gym_online.jpg';
import gym_recorded from '../../../assets/images/gym_recorded.jpg';
import leths_back from '../../../assets/images/leths_back.png';
import { appColors } from '../../../assets/styles/global';
import { Header } from '../../../components/common';
import { AppButton } from '../../../components/form';
import { Logout } from '../../../config/utils';
import { ImageButton } from '../../login/baseWithButtons';
import styles from './styles';

const WorkerProfile = ({ navigation }) => {
  const { workerData } = useSelector((state) => state.worker);
  const returnMaskedNumber = (number) => (number.toString().length < 4 ? returnMaskedNumber(`0${number}`) : number.toString());
  return (
    <ImageBackground source={leths_back} style={styles.viewBase}>
      <Header canAlterPic="Worker Alter Pic" profilePic={workerData?.foto} coins={workerData?.saldo_moedas ? returnMaskedNumber(workerData?.saldo_moedas) : returnMaskedNumber(0)} navigation={navigation} userName={workerData?.nome} />
      <View style={styles.container}>
        <ImageButton innerStyle={styles.viewInner} style={styles.buttonReduced} navigation={navigation} image={gym_online} text={'GINÁSTICA LABORAL\nONLINE'} colors={['#FFF', appColors.primary]} route="Worker Online Gym" />
        <ImageButton innerStyle={styles.viewInner} style={styles.buttonReduced} navigation={navigation} image={gym_recorded} text={'GINÁSTICA LABORAL\nGRAVADA'} colors={['#FFF', appColors.primary]} route="Worker Recorded Gym" />
        <ImageButton innerStyle={styles.viewInner} style={styles.buttonReduced} navigation={navigation} image={gym_insitu} text={'GINÁSTICA LABORAL\nPRESENCIAL'} colors={['#FFF', appColors.primary]} route="Worker InPerson Gym" />
      </View>
      <AppButton size="bold" label="SAIR" rippleColor={Colors.white} style={styles.buttonBack} labelStyle={styles.textBack} onPress={() => Logout(navigation)} />
    </ImageBackground>
  );
};

export default WorkerProfile;
